module.exports = __webpack_public_path__ + "img/tooth.87c5ecae.png";